export default "__VITE_ASSET__dd1eb769__"